import { render, staticRenderFns } from "./ManageCampaignSettings.vue?vue&type=template&id=13b5f4dc&scoped=true&lang=pug&"
import script from "./ManageCampaignSettings.vue?vue&type=script&lang=js&"
export * from "./ManageCampaignSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5f4dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
